module.exports = __webpack_public_path__ + "img/child-3.1684c7d.jpg?v=1745003750678";